import script from "./ActivitySetup.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivitySetup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__